import React, { useState, useEffect } from "react";
import api from "../utils/axiosInstance";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { getApiBase } from "../utils/useApiBase";
const PHOTO_MAX_SIZE = 2 * 1024 * 1024;
const allowedPhotoTypes = new Set(["image/jpeg", "image/png"]);
const allowedPhotoExtensions = /\.(jpe?g|png)$/i;
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";
const getPhotoUrl = (filename) =>
  filename ? `${API_BASE}/uploads/photos/${filename}` : "";
const handleImgError = (e) => { e.target.style.display = "none"; e.target.nextSibling && (e.target.nextSibling.style.display = "flex"); };

const Urubyiruko = ({ isUmudugudu = false }) => {
  const API_URL = isUmudugudu
    ? `${getApiBase()}/umudugudu/module-data/urubyiruko`
    : `${getApiBase()}/urubyiruko`;
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", variant: "" });
  const [show, setShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedYouth, setSelectedYouth] = useState(null);
  const [editId, setEditId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterGender, setFilterGender] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterAge, setFilterAge] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [activeView, setActiveView] = useState("table");
  const [expandedMobileCard, setExpandedMobileCard] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [openFilter, setOpenFilter] = useState(null);

  const [stats, setStats] = useState({
    total: 0, male: 0, female: 0, employed: 0, unemployed: 0, avgAge: 0,
  });

  const [form, setForm] = useState({
    amazina: "", imyaka: "", igitsina: "Gabo", umurimo: "",
    nimero_ya_telephone: "", aderesi: "", id_number: "", status: "Rudafite akazi", ifoto: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);

  const [formErrors, setFormErrors] = useState({});

  const calculateStats = (arr) => {
    if (!arr.length) {
      setStats({ total: 0, male: 0, female: 0, employed: 0, unemployed: 0, avgAge: 0 });
      return;
    }
    const totalAge = arr.reduce((s, i) => s + parseInt(i.imyaka || 0), 0);
    setStats({
      total: arr.length,
      male: arr.filter(i => i.igitsina === "Gabo").length,
      female: arr.filter(i => i.igitsina === "Gore").length,
      employed: arr.filter(i => i.status === "Rufite akazi").length,
      unemployed: arr.filter(i => i.status === "Rudafite akazi").length,
      avgAge: (totalAge / arr.length).toFixed(1),
    });
  };

  const showAlertMessage = (message, variant = "success") => {
    setAlert({ show: true, message, variant });
    setTimeout(() => setAlert({ show: false, message: "", variant: "" }), 4000);
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await api.get(API_URL);
      const items = Array.isArray(res.data) ? res.data : [];
      setData(items);
      setFilteredData(items);
      calculateStats(items);
    } catch (err) {
      console.error(err);
      showAlertMessage("Habaye ikosa mu gusoma amakuru!", "danger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  useEffect(() => {
    let result = [...data];
    if (searchTerm) {
      result = result.filter(i =>
        i.amazina?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        i.umurimo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        i.nimero_ya_telephone?.includes(searchTerm) ||
        i.id_number?.includes(searchTerm)
      );
    }
    if (filterGender !== "all") result = result.filter(i => i.igitsina === filterGender);
    if (filterStatus !== "all") result = result.filter(i => i.status === filterStatus);
    if (filterAge !== "all") {
      result = result.filter(i => {
        const age = parseInt(i.imyaka);
        if (filterAge === "15-20") return age >= 15 && age <= 20;
        if (filterAge === "21-25") return age >= 21 && age <= 25;
        if (filterAge === "26-30") return age >= 26 && age <= 30;
        if (filterAge === "31+") return age >= 31;
        return true;
      });
    }
    setFilteredData(result);
    setCurrentPage(1);
  }, [searchTerm, filterGender, filterStatus, filterAge, data]);

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const validateForm = () => {
    const errors = {};
    if (!form.amazina?.trim()) errors.amazina = "Amazina ni ngombwa";
    if (!form.imyaka || parseInt(form.imyaka) < 15 || parseInt(form.imyaka) > 35)
      errors.imyaka = "Imyaka: 15–35";
    if (form.nimero_ya_telephone && !/^07[2389]\d{7}$/.test(form.nimero_ya_telephone))
      errors.nimero_ya_telephone = "Formato: 078XXXXXXX";
    if (form.id_number && form.id_number.length !== 16)
      errors.id_number = "Imibare 16 gusa";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (formErrors[name]) setFormErrors({ ...formErrors, [name]: "" });
  };

  const initialForm = {
    amazina: "", imyaka: "", igitsina: "Gabo", umurimo: "",
    nimero_ya_telephone: "", aderesi: "", id_number: "", status: "Rudafite akazi", ifoto: "",
  };

  const resetForm = () => { setForm(initialForm); setSelectedFile(null); setFormErrors({}); setEditId(null); };

  const handleSave = async () => {
    if (!validateForm()) { showAlertMessage("Uzuza neza amakuru!", "warning"); return; }
    try {
      const formData = new FormData();
      Object.entries(form).forEach(([key, value]) => {
        if (key !== "ifoto") formData.append(key, value ?? "");
      });
      if (selectedFile) formData.append("ifoto", selectedFile);

      if (editId) {
        await api.put(`${API_URL}/${editId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        showAlertMessage("Amakuru yahinduwe neza!", "success");
      } else {
        await api.post(API_URL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        showAlertMessage("Yashyizwemo neza!", "success");
      }
      setShow(false);
      resetForm();
      loadData();
    } catch (err) {
      console.error(err);
      showAlertMessage("Ntibikunze kubika!", "danger");
    }
  };

  const handleEdit = (item) => {
    setForm({
      amazina: item.amazina || "",
      imyaka: item.imyaka || "",
      igitsina: item.igitsina || "Gabo",
      umurimo: item.umurimo || "",
      nimero_ya_telephone: item.nimero_ya_telephone || "",
      aderesi: item.aderesi || "",
      id_number: item.id_number || "",
      status: item.status || "Rudafite akazi",
      ifoto: item.ifoto || "",
    });
    setSelectedFile(null);
    setEditId(item.id);
    setFormErrors({});
    setShow(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setSelectedFile(null);
      setForm((prev) => ({ ...prev, ifoto: editId ? prev.ifoto : "" }));
      setFormErrors((prev) => {
        const next = { ...prev };
        delete next.ifoto;
        return next;
      });
      return;
    }

    if (
      ((!allowedPhotoTypes.has(file.type) && file.type) ||
        !allowedPhotoExtensions.test(file.name || ""))
    ) {
      setSelectedFile(null);
      setFormErrors((prev) => ({
        ...prev,
        ifoto: "Ifoto igomba kuba JPG, JPEG cyangwa PNG",
      }));
      e.target.value = "";
      return;
    }

    if (file.size > PHOTO_MAX_SIZE) {
      setSelectedFile(null);
      setFormErrors((prev) => ({
        ...prev,
        ifoto: "Ifoto ntigomba kurenza 2MB",
      }));
      e.target.value = "";
      return;
    }

    setSelectedFile(file);
    setForm((prev) => ({ ...prev, ifoto: file.name }));
    setFormErrors((prev) => {
      const next = { ...prev };
      delete next.ifoto;
      return next;
    });
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`${API_URL}/${id}`);
      showAlertMessage("Yasibwe neza!", "success");
      setDeleteConfirm(null);
      loadData();
    } catch (err) {
      console.error(err);
      showAlertMessage("Ntibikunze gusiba!", "danger");
    }
  };

  const exportToCSV = () => {
    const headers = ["Amazina", "Imyaka", "Igitsina", "Umurimo", "Telefoni", "Aderesi", "ID", "Status"];
    const csvData = filteredData.map(i => [
      i.amazina, i.imyaka, i.igitsina, i.umurimo || "-",
      i.nimero_ya_telephone || "-", i.aderesi || "-", i.id_number || "-", i.status,
    ]);
    const csvContent = [headers.join(","), ...csvData.map(r => r.join(","))].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `urubyiruko_${new Date().toISOString().split("T")[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlertMessage("Excel yakoboye neza!", "success");
  };

  const genderColor = (g) => g === "Gabo"
    ? { bg: "rgba(3,105,161,0.12)", color: "#0369a1", border: "rgba(3,105,161,0.22)" }
    : { bg: "rgba(220,38,38,0.12)", color: "#dc2626", border: "rgba(220,38,38,0.22)" };

  const statusColor = (s) => s === "Rufite akazi"
    ? { bg: "rgba(22,163,74,0.12)", color: "#16a34a", border: "rgba(22,163,74,0.22)" }
    : { bg: "rgba(220,38,38,0.1)", color: "#dc2626", border: "rgba(220,38,38,0.2)" };

  const activeFilters = [filterGender !== "all", filterStatus !== "all", filterAge !== "all"].filter(Boolean).length;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700;800;900&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .ub-root {
          font-family: 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          -webkit-tap-highlight-color: transparent;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: rgba(11,61,145,0.25); border-radius: 10px; }

        @keyframes fadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.94); } to { opacity: 1; transform: scale(1); } }
        @keyframes slideRow { from { opacity: 0; transform: translateX(-16px); } to { opacity: 1; transform: translateX(0); } }
        @keyframes alertPop {
          0% { opacity: 0; transform: translateY(-20px) scale(0.9); }
          60% { transform: translateY(3px) scale(1.01); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes gradientFlow {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        @keyframes pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.06); } }
        @keyframes dotBounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1); }
        }
        @keyframes shimmer {
          0% { left: -100%; }
          100% { left: 200%; }
        }
        @keyframes breathe {
          0%, 100% { box-shadow: 0 0 0 0 rgba(11,61,145,0); }
          50% { box-shadow: 0 0 0 8px rgba(11,61,145,0.06); }
        }
        @keyframes modalIn {
          from { opacity: 0; transform: scale(0.92) translateY(20px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes overlayIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(100%); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes progressFill {
          from { width: 0; }
        }
        @keyframes countUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .ub-app {
          min-height: 100vh;
          min-height: 100dvh;
          background: #ffffff;
          color: #0d1b2a;
          position: relative;
          overflow-x: hidden;
        }
        .ub-app::before {
          content: '';
          position: fixed;
          inset: 0;
          background:
            radial-gradient(ellipse 80% 50% at 15% 8%, rgba(11,61,145,0.08) 0%, transparent 55%),
            radial-gradient(ellipse 60% 70% at 88% 90%, rgba(3,105,161,0.05) 0%, transparent 50%),
            radial-gradient(ellipse 40% 40% at 50% 50%, rgba(11,61,145,0.03) 0%, transparent 45%);
          pointer-events: none;
          z-index: 0;
        }

        .ub-content {
          position: relative;
          z-index: 1;
          max-width: 1400px;
          margin: 0 auto;
          padding: 20px 16px 48px;
        }

        .ub-glass {
          background: linear-gradient(140deg, rgba(255,255,255,0.88), rgba(240,244,251,0.96));
          backdrop-filter: blur(24px) saturate(1.2);
          -webkit-backdrop-filter: blur(24px) saturate(1.2);
          border: 1px solid rgba(11,61,145,0.055);
          border-radius: 22px;
          transition: border-color 0.4s ease, box-shadow 0.4s ease;
        }
        .ub-glass:hover {
          border-color: rgba(11,61,145,0.1);
        }

        /* ── Header ── */
        .ub-header { text-align: center; margin-bottom: 32px; animation: fadeUp 0.5s ease; }
        .ub-header-badge {
          display: inline-flex; align-items: center; gap: 7px;
          padding: 5px 14px; border-radius: 10px;
          background: rgba(11,61,145,0.1); border: 1px solid rgba(11,61,145,0.18);
          color: #0B3D91; font-size: 0.7rem; font-weight: 700;
          letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 14px;
        }
        .ub-title {
          font-size: clamp(1.5rem, 5vw, 2.6rem); font-weight: 900; line-height: 1.1; margin-bottom: 8px;
          background: linear-gradient(135deg, #0B3D91, #0B3D91, #0B3D91, #0B3D91);
          background-size: 300% 300%; animation: gradientFlow 7s ease infinite;
          -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
        }
        .ub-subtitle { color: #64748b; font-size: clamp(0.82rem, 2vw, 0.95rem); max-width: 440px; margin: 0 auto; }

        /* ── Stats ── */
        .ub-stats {
          display: grid; grid-template-columns: repeat(4, 1fr);
          gap: 12px; margin-bottom: 28px; animation: fadeUp 0.6s ease;
        }
        .ub-stat {
          background: linear-gradient(145deg, rgba(240,244,251,0.9), rgba(255,255,255,0.96));
          backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);
          border: 1px solid rgba(11,61,145,0.05); border-radius: 18px;
          padding: 22px 14px; text-align: center; position: relative; overflow: hidden;
          transition: all 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        .ub-stat::after {
          content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px;
          border-radius: 18px 18px 0 0; opacity: 0; transition: opacity 0.35s ease;
        }
        .ub-stat:hover { transform: translateY(-6px); border-color: rgba(11,61,145,0.08); }
        .ub-stat:hover::after { opacity: 1; }
        .ub-stat.violet::after { background: linear-gradient(90deg, #0B3D91, #0B3D91); }
        .ub-stat.violet:hover { box-shadow: 0 14px 44px rgba(11,61,145,0.12); }
        .ub-stat.emerald::after { background: linear-gradient(90deg, #16a34a, #16a34a); }
        .ub-stat.emerald:hover { box-shadow: 0 14px 44px rgba(22,163,74,0.12); }
        .ub-stat.rose::after { background: linear-gradient(90deg, #dc2626, #dc2626); }
        .ub-stat.rose:hover { box-shadow: 0 14px 44px rgba(220,38,38,0.12); }
        .ub-stat.amber::after { background: linear-gradient(90deg, #d97706, #d97706); }
        .ub-stat.amber:hover { box-shadow: 0 14px 44px rgba(217,119,6,0.12); }

        .ub-stat-icon {
          width: 46px; height: 46px; border-radius: 14px;
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 1.2rem; margin-bottom: 12px; transition: transform 0.3s ease;
        }
        .ub-stat:hover .ub-stat-icon { transform: scale(1.12) rotate(-5deg); }
        .ub-stat-val {
          font-size: clamp(1.4rem, 3vw, 2.1rem); font-weight: 800;
          color: #0d1b2a; line-height: 1; margin-bottom: 4px; letter-spacing: -0.03em;
          animation: countUp 0.6s ease;
        }
        .ub-stat-lbl {
          font-size: 0.63rem; color: #64748b;
          font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em;
        }
        .ub-stat-sub {
          font-size: 0.68rem; color: #94a3b8; margin-top: 6px;
        }
        .ub-progress-track {
          width: 100%; height: 4px; background: rgba(11,61,145,0.06);
          border-radius: 4px; margin-top: 10px; overflow: hidden;
        }
        .ub-progress-fill {
          height: 100%; border-radius: 4px; animation: progressFill 1s ease;
          transition: width 0.6s ease;
        }

        /* ── Toolbar ── */
        .ub-toolbar {
          display: flex; flex-wrap: wrap; gap: 10px; align-items: center;
          justify-content: space-between; margin-bottom: 20px; animation: fadeUp 0.7s ease;
        }
        .ub-toolbar-left { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; flex: 1; min-width: 0; }
        .ub-toolbar-right { display: flex; gap: 8px; flex-shrink: 0; }

        .ub-search-wrap { position: relative; flex: 1; min-width: 200px; max-width: 380px; }
        .ub-search-icon {
          position: absolute; left: 14px; top: 50%; transform: translateY(-50%);
          color: rgba(11,61,145,0.2); font-size: 0.95rem; z-index: 2; pointer-events: none;
          transition: color 0.3s ease;
        }
        .ub-search-wrap:focus-within .ub-search-icon { color: #0B3D91; }
        .ub-search {
          width: 100%; padding: 11px 14px 11px 42px;
          background: rgba(240,244,251,0.6); border: 1.5px solid rgba(11,61,145,0.06);
          border-radius: 13px; color: #0d1b2a; font-size: 0.88rem; font-weight: 500;
          font-family: inherit; outline: none; transition: all 0.3s ease;
        }
        .ub-search::placeholder { color: rgba(11,61,145,0.2); }
        .ub-search:focus {
          border-color: #0B3D91;
          box-shadow: 0 0 0 3px rgba(11,61,145,0.1);
          background: rgba(240,244,251,0.85);
        }

        .ub-filter-chip {
          padding: 9px 16px; border-radius: 11px;
          background: rgba(240,244,251,0.6); border: 1.5px solid rgba(11,61,145,0.06);
          color: rgba(11,61,145,0.55); font-size: 0.8rem; font-weight: 600;
          font-family: inherit; cursor: pointer; transition: all 0.3s ease;
          display: inline-flex; align-items: center; gap: 6px; position: relative;
          white-space: nowrap;
        }
        .ub-filter-chip:hover { border-color: rgba(11,61,145,0.2); color: rgba(11,61,145,0.8); }
        .ub-filter-chip.active {
          background: rgba(11,61,145,0.1); border-color: rgba(11,61,145,0.3); color: #0B3D91;
        }
        .ub-filter-dropdown {
          position: absolute; top: calc(100% + 6px); left: 0; min-width: 160px;
          background: rgba(240,244,251,0.97); backdrop-filter: blur(20px);
          border: 1px solid rgba(11,61,145,0.08); border-radius: 14px;
          padding: 6px; z-index: 50; animation: scaleIn 0.2s ease;
          box-shadow: 0 12px 40px rgba(0,0,0,0.5);
        }
        .ub-filter-option {
          display: block; width: 100%; padding: 10px 14px;
          background: none; border: none; border-radius: 10px;
          color: rgba(11,61,145,0.65); font-size: 0.82rem; font-weight: 500;
          font-family: inherit; cursor: pointer; text-align: left;
          transition: all 0.2s ease;
        }
        .ub-filter-option:hover { background: rgba(11,61,145,0.08); color: #0d1b2a; }
        .ub-filter-option.selected {
          background: rgba(11,61,145,0.12); color: #0B3D91; font-weight: 700;
        }
        .ub-filter-badge {
          display: inline-flex; align-items: center; justify-content: center;
          width: 20px; height: 20px; border-radius: 6px;
          background: rgba(11,61,145,0.2); color: #0B3D91;
          font-size: 0.65rem; font-weight: 800;
        }

        .ub-icon-btn {
          width: 42px; height: 42px; border-radius: 12px;
          background: rgba(240,244,251,0.6); border: 1.5px solid rgba(11,61,145,0.06);
          color: rgba(11,61,145,0.5); font-size: 1rem;
          display: inline-flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all 0.3s ease; font-family: inherit;
          min-width: 44px; min-height: 44px;
        }
        .ub-icon-btn:hover { border-color: rgba(11,61,145,0.2); color: #0B3D91; transform: translateY(-2px); }
        .ub-icon-btn.primary {
          background: linear-gradient(135deg, #0B3D91, #0B3D91); border: none;
          color: #ffffff; box-shadow: 0 4px 16px rgba(11,61,145,0.3);
        }
        .ub-icon-btn.primary:hover {
          transform: translateY(-2px); box-shadow: 0 8px 24px rgba(11,61,145,0.45);
        }

        .ub-btn {
          padding: 10px 20px; border-radius: 12px;
          font-size: 0.85rem; font-weight: 650; font-family: inherit;
          cursor: pointer; transition: all 0.3s ease;
          display: inline-flex; align-items: center; gap: 7px; border: none;
          white-space: nowrap;
          min-height: 44px;
        }
        .ub-btn-primary {
          background: linear-gradient(135deg, #0B3D91, #0B3D91);
          color: #ffffff; box-shadow: 0 4px 16px rgba(11,61,145,0.3);
        }
        .ub-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(11,61,145,0.45); }
        .ub-btn-ghost {
          background: transparent; color: rgba(11,61,145,0.5);
          border: 1.5px solid rgba(11,61,145,0.08);
        }
        .ub-btn-ghost:hover { color: #0d1b2a; border-color: rgba(11,61,145,0.2); }
        .ub-btn-success {
          background: rgba(22,163,74,0.12); color: #16a34a;
          border: 1px solid rgba(22,163,74,0.2);
        }
        .ub-btn-success:hover { background: rgba(22,163,74,0.2); transform: translateY(-2px); }
        .ub-btn-danger {
          background: rgba(220,38,38,0.1); color: #dc2626;
          border: 1px solid rgba(220,38,38,0.18);
        }
        .ub-btn-danger:hover { background: rgba(220,38,38,0.18); }

        /* ── Alert ── */
        .ub-alert {
          padding: 14px 18px; border-radius: 16px;
          display: flex; align-items: center; gap: 12px;
          font-weight: 550; font-size: 0.88rem;
          margin-bottom: 20px; animation: alertPop 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
          border: 1px solid;
        }
        .ub-alert-success { background: rgba(22,163,74,0.07); border-color: rgba(22,163,74,0.18); color: #16a34a; }
        .ub-alert-danger { background: rgba(220,38,38,0.07); border-color: rgba(220,38,38,0.18); color: #dc2626; }
        .ub-alert-warning { background: rgba(217,119,6,0.07); border-color: rgba(217,119,6,0.18); color: #d97706; }
        .ub-alert-info { background: rgba(3,105,161,0.07); border-color: rgba(3,105,161,0.18); color: #0369a1; }
        .ub-alert-icon {
          width: 36px; height: 36px; min-width: 36px; border-radius: 10px;
          display: flex; align-items: center; justify-content: center; font-size: 1rem;
        }
        .ub-alert-close {
          margin-left: auto; background: none; border: none;
          color: inherit; cursor: pointer; padding: 4px; opacity: 0.6;
          font-size: 1rem; font-family: inherit; transition: opacity 0.2s;
        }
        .ub-alert-close:hover { opacity: 1; }

        /* ── Table ── */
        .ub-table-wrap {
          border-radius: 16px; overflow: hidden;
          border: 1px solid rgba(11,61,145,0.04);
          position: relative;
        }
        .ub-table-scroll {
          max-height: 540px;
          max-width: 100%;
          overflow: auto;
          overscroll-behavior: contain;
          -webkit-overflow-scrolling: touch;
        }
        .ub-table { width: max(100%, 1020px); border-collapse: separate; border-spacing: 0; }
        .ub-table thead { position: sticky; top: 0; z-index: 5; }
        .ub-table th {
          padding: 14px 16px; font-size: 0.67rem; font-weight: 700;
          text-transform: uppercase; letter-spacing: 0.1em;
          color: #0B3D91; border-bottom: 1px solid rgba(11,61,145,0.05);
          background: rgba(255,255,255,0.97); backdrop-filter: blur(8px);
          white-space: nowrap; text-align: left;
        }
        .ub-table td {
          padding: 14px 16px; font-size: 0.85rem;
          color: #374151; border-bottom: 1px solid rgba(11,61,145,0.025);
          vertical-align: middle;
        }
        .ub-table tbody tr { transition: all 0.25s ease; cursor: default; }
        .ub-table tbody tr:hover { background: rgba(11,61,145,0.04); }
        .ub-table tbody tr:last-child td { border-bottom: none; }

        .ub-tag {
          display: inline-flex; align-items: center; padding: 3px 10px;
          border-radius: 7px; font-size: 0.72rem; font-weight: 650;
          letter-spacing: 0.02em; border: 1px solid; white-space: nowrap;
        }

        .ub-action-group { display: flex; gap: 6px; justify-content: center; }
        .ub-action-btn {
          width: 36px; height: 36px; border-radius: 10px;
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 0.85rem; cursor: pointer; transition: all 0.25s ease;
          border: 1px solid transparent; background: transparent;
        }
        .ub-action-btn.view { color: rgba(3,105,161,0.7); }
        .ub-action-btn.view:hover { background: rgba(3,105,161,0.1); color: #0369a1; border-color: rgba(3,105,161,0.2); }
        .ub-action-btn.edit { color: #0B3D91; }
        .ub-action-btn.edit:hover { background: rgba(11,61,145,0.1); color: #0B3D91; border-color: rgba(11,61,145,0.2); }
        .ub-action-btn.delete { color: rgba(220,38,38,0.6); }
        .ub-action-btn.delete:hover { background: rgba(220,38,38,0.1); color: #dc2626; border-color: rgba(220,38,38,0.2); }

        /* ── Pagination ── */
        .ub-pagination {
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 12px; margin-top: 18px; padding: 0 4px;
        }
        .ub-page-info { font-size: 0.78rem; color: #64748b; font-weight: 500; }
        .ub-page-btns { display: flex; gap: 4px; flex-wrap: wrap; justify-content: flex-end; }
        .ub-page-btn {
          width: 36px; height: 36px; border-radius: 10px;
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 0.8rem; font-weight: 600; font-family: inherit;
          cursor: pointer; transition: all 0.25s ease;
          background: transparent; border: 1px solid rgba(11,61,145,0.05);
          color: #64748b;
        }
        .ub-page-btn:hover:not(:disabled) { border-color: rgba(11,61,145,0.2); color: #0B3D91; }
        .ub-page-btn.active {
          background: linear-gradient(135deg, #0B3D91, #0B3D91);
          color: #ffffff; border-color: transparent;
          box-shadow: 0 2px 10px rgba(11,61,145,0.3);
        }
        .ub-page-btn:disabled { opacity: 0.3; cursor: not-allowed; }

        /* ── Mobile Cards ── */
        .ub-mobile-card {
          display: none;
          background: rgba(240,244,251,0.6); border: 1px solid rgba(11,61,145,0.05);
          border-radius: 16px; padding: 18px; margin-bottom: 10px;
          transition: all 0.3s ease; cursor: pointer;
        }
        .ub-mobile-card:active { background: rgba(11,61,145,0.05); border-color: rgba(11,61,145,0.1); }
        .ub-mc-head { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px; }
        .ub-mc-name { font-weight: 700; color: #0d1b2a; font-size: 0.95rem; margin-bottom: 5px; }
        .ub-mc-row {
          display: flex; justify-content: space-between; padding: 7px 0;
          border-bottom: 1px solid rgba(11,61,145,0.025); font-size: 0.82rem;
        }
        .ub-mc-row:last-child { border-bottom: none; }
        .ub-mc-lbl { color: #64748b; font-weight: 500; }
        .ub-mc-val {
          color: #374151;
          font-weight: 600;
          text-align: right;
          max-width: 62%;
          overflow-wrap: anywhere;
        }
        .ub-mc-actions { display: flex; gap: 8px; margin-top: 12px; padding-top: 12px; border-top: 1px solid rgba(11,61,145,0.04); }
        .ub-mc-actions .ub-btn { flex: 1; justify-content: center; padding: 10px; font-size: 0.8rem; }

        /* ── Modal Overlay ── */
        .ub-overlay {
          position: fixed; inset: 0; z-index: 1000;
          background: rgba(0,0,0,0.7); backdrop-filter: blur(8px);
          display: flex; align-items: flex-start; justify-content: center;
          padding: 16px; animation: overlayIn 0.25s ease;
          overflow-y: auto;
        }
        .ub-modal {
          width: 100%; max-width: 640px;
          background: linear-gradient(145deg, rgba(255,255,255,0.98), rgba(240,244,251,0.99));
          border: 1px solid rgba(11,61,145,0.08); border-radius: 24px;
          animation: modalIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
          box-shadow: 0 24px 80px rgba(0,0,0,0.6);
          margin: auto;
        }
        .ub-modal-head {
          display: flex; align-items: center; justify-content: space-between;
          padding: 24px 28px 0;
        }
        .ub-modal-title {
          display: flex; align-items: center; gap: 12px;
          font-size: 1.15rem; font-weight: 800; color: #0d1b2a;
        }
        .ub-modal-title-icon {
          width: 44px; height: 44px; border-radius: 13px;
          background: linear-gradient(135deg, #0B3D91, #0B3D91);
          display: flex; align-items: center; justify-content: center;
          font-size: 1.1rem; color: #ffffff; flex-shrink: 0;
          box-shadow: 0 4px 14px rgba(11,61,145,0.3);
        }
        .ub-modal-close {
          width: 36px; height: 36px; border-radius: 10px;
          background: rgba(11,61,145,0.04); border: 1px solid rgba(11,61,145,0.06);
          color: #64748b; font-size: 1rem;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all 0.2s ease;
        }
        .ub-modal-close:hover { background: rgba(220,38,38,0.1); color: #dc2626; border-color: rgba(220,38,38,0.2); }
        .ub-modal-body { padding: 24px 28px; }
        .ub-modal-footer {
          display: flex; gap: 10px; justify-content: flex-end;
          padding: 0 28px 24px; flex-wrap: wrap;
        }

        /* ── Form Fields ── */
        .ub-field { margin-bottom: 0; }
        .ub-label {
          display: flex; align-items: center; gap: 6px;
          font-size: 0.7rem; font-weight: 700;
          color: #64748b; margin-bottom: 8px;
          text-transform: uppercase; letter-spacing: 0.08em;
          transition: color 0.3s ease;
        }
        .ub-field:focus-within .ub-label { color: #0B3D91; }
        .ub-req { color: #dc2626; font-size: 0.85rem; }

        .ub-input-wrap { position: relative; }
        .ub-input-icon {
          position: absolute; left: 14px; top: 50%; transform: translateY(-50%);
          color: rgba(11,61,145,0.18); font-size: 0.9rem;
          transition: color 0.3s ease; z-index: 2; pointer-events: none;
        }
        .ub-field:focus-within .ub-input-icon { color: #0B3D91; }

        .ub-input {
          width: 100%; padding: 13px 14px 13px 42px;
          background: rgba(11,61,145,0.03);
          border: 1.5px solid rgba(11,61,145,0.07);
          border-radius: 13px; min-height: 50px; color: #0d1b2a; font-size: 0.92rem; font-weight: 500;
          font-family: inherit; outline: none; transition: all 0.25s ease;
          -webkit-appearance: none; appearance: none;
        }
        .ub-input.no-icon { padding-left: 14px; }
        .ub-input::placeholder { color: rgba(11,61,145,0.15); }
        .ub-input:hover:not(:focus) { border-color: rgba(11,61,145,0.11); background: rgba(11,61,145,0.04); }
        .ub-input:focus {
          border-color: #0B3D91;
          box-shadow: 0 0 0 3px rgba(11,61,145,0.12), 0 2px 8px rgba(11,61,145,0.08);
          background: rgba(11,61,145,0.04);
        }
        .ub-input.error { border-color: rgba(220,38,38,0.6); background: rgba(220,38,38,0.03); }
        .ub-input.error:focus { box-shadow: 0 0 0 3px rgba(220,38,38,0.12); }

        .ub-select {
          width: 100%; padding: 13px 36px 13px 42px;
          background: rgba(11,61,145,0.03);
          border: 1.5px solid rgba(11,61,145,0.07);
          border-radius: 13px; min-height: 50px; color: #0d1b2a; font-size: 0.92rem; font-weight: 500;
          font-family: inherit; outline: none; transition: all 0.25s ease;
          cursor: pointer; -webkit-appearance: none; appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='rgba(11,61,145,0.6)' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
          background-repeat: no-repeat; background-position: right 14px center;
        }
        .ub-select:hover:not(:focus) { border-color: rgba(11,61,145,0.11); }
        .ub-select:focus {
          border-color: #0B3D91;
          box-shadow: 0 0 0 3px rgba(11,61,145,0.12), 0 2px 8px rgba(11,61,145,0.08);
          background-color: rgba(11,61,145,0.04);
        }

        /* File input */
        .ub-file-zone {
          width: 100%; min-height: 80px;
          border: 1.5px dashed rgba(11,61,145,0.2);
          border-radius: 13px; background: rgba(11,61,145,0.03);
          display: flex; align-items: center; justify-content: center;
          gap: 10px; padding: 14px 16px; cursor: pointer;
          transition: all 0.25s ease; position: relative; overflow: hidden;
        }
        .ub-file-zone:hover { border-color: rgba(11,61,145,0.4); background: rgba(11,61,145,0.06); }
        .ub-file-zone.has-file { border-style: solid; border-color: rgba(11,61,145,0.3); background: rgba(11,61,145,0.05); }
        .ub-file-zone.error { border-color: rgba(220,38,38,0.4); background: rgba(220,38,38,0.03); }
        .ub-file-zone input[type="file"] {
          position: absolute; inset: 0; opacity: 0; cursor: pointer; width: 100%; height: 100%;
        }
        .ub-file-icon {
          width: 40px; height: 40px; border-radius: 11px; flex-shrink: 0;
          background: rgba(11,61,145,0.12); border: 1px solid rgba(11,61,145,0.2);
          display: flex; align-items: center; justify-content: center;
          color: #0B3D91; font-size: 1.1rem;
        }
        .ub-file-text { flex: 1; min-width: 0; }
        .ub-file-title { font-size: 0.82rem; font-weight: 600; color: #374151; margin-bottom: 2px; }
        .ub-file-sub { font-size: 0.7rem; color: #94a3b8; }
        .ub-file-name { font-size: 0.78rem; color: #0B3D91; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

        .ub-select option { background: #ffffff; color: #0d1b2a; }
        .ub-field-error {
          display: flex; align-items: center; gap: 5px;
          font-size: 0.7rem; color: #dc2626; margin-top: 6px; font-weight: 600;
        }

        .ub-form-grid { display: grid; gap: 18px; }
        .ub-form-grid-2 { grid-template-columns: repeat(2, 1fr); }
        .ub-form-grid-3 { grid-template-columns: repeat(3, 1fr); }

        /* Form section divider */
        .ub-form-section {
          padding: 14px 16px; border-radius: 12px;
          background: rgba(11,61,145,0.02); border: 1px solid rgba(11,61,145,0.04);
          margin-bottom: 14px;
        }
        .ub-form-section-title {
          font-size: 0.65rem; font-weight: 800; text-transform: uppercase;
          letter-spacing: 0.12em; color: #0B3D91;
          margin-bottom: 14px; display: flex; align-items: center; gap: 7px;
        }
        .ub-form-section-title::after {
          content: ''; flex: 1; height: 1px; background: rgba(11,61,145,0.1);
        }

        /* ── Delete Confirm ── */
        .ub-delete-modal {
          max-width: 400px; text-align: center; padding: 36px 28px;
          border-radius: 24px;
        }
        .ub-delete-icon {
          width: 64px; height: 64px; border-radius: 20px;
          background: rgba(220,38,38,0.1); border: 1px solid rgba(220,38,38,0.15);
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 1.6rem; color: #dc2626; margin-bottom: 18px;
        }
        .ub-delete-btns { display: flex; gap: 10px; justify-content: center; margin-top: 20px; }

        /* ── Details Modal ── */
        .ub-detail-row {
          display: flex; justify-content: space-between; padding: 12px 0;
          border-bottom: 1px solid rgba(11,61,145,0.04); font-size: 0.88rem;
        }
        .ub-detail-row:last-child { border-bottom: none; }
        .ub-detail-lbl { color: #64748b; font-weight: 500; }
        .ub-detail-val { color: #0d1b2a; font-weight: 600; text-align: right; }
        .ub-detail-header {
          text-align: center; padding-bottom: 20px; margin-bottom: 8px;
          border-bottom: 1px solid rgba(11,61,145,0.05);
        }
        .ub-detail-avatar {
          width: 72px; height: 72px; border-radius: 20px;
          background: linear-gradient(135deg, rgba(11,61,145,0.15), rgba(11,61,145,0.15));
          border: 2px solid rgba(11,61,145,0.2);
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 1.8rem; margin-bottom: 12px;
        }

        /* ── Empty / Loader ── */
        .ub-empty { text-align: center; padding: 56px 20px; }
        .ub-empty-icon {
          width: 72px; height: 72px; border-radius: 22px;
          background: rgba(11,61,145,0.06); border: 1px solid rgba(11,61,145,0.1);
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 1.8rem; color: #94a3b8; margin-bottom: 18px;
        }
        .ub-loader {
          display: flex; gap: 6px; justify-content: center;
          align-items: center; padding: 56px;
        }
        .ub-loader span {
          width: 10px; height: 10px; border-radius: 50%;
          background: #0B3D91; animation: dotBounce 1.4s infinite ease-in-out both;
        }
        .ub-loader span:nth-child(1) { animation-delay: -0.32s; }
        .ub-loader span:nth-child(2) { animation-delay: -0.16s; }

        /* ── Footer ── */
        .ub-footer {
          text-align: center; margin-top: 36px;
          color: #94a3b8; font-size: 0.73rem; font-weight: 500;
        }

        /* ── Responsive ── */
        @media (max-width: 991px) {
          .ub-stats { grid-template-columns: repeat(2, 1fr); }
          .ub-form-grid-3 { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 767px) {
          .ub-content { padding: 14px 10px 36px; }
          .ub-desktop-table { display: none !important; }
          .ub-mobile-card { display: block !important; }
          .ub-toolbar { flex-direction: column; align-items: stretch; }
          .ub-toolbar-left { flex-direction: column; }
          .ub-toolbar-right { justify-content: space-between; width: 100%; }
          .ub-toolbar-right .ub-icon-btn { flex: 1; }
          .ub-search-wrap { max-width: 100%; }
          .ub-form-grid-2, .ub-form-grid-3 { grid-template-columns: 1fr; }
          .ub-modal { border-radius: 20px; margin: 8px auto; }
          .ub-modal-body { padding: 16px; padding-top: 16px; }
          .ub-modal-head { padding: 18px 16px 0; }
          .ub-modal-footer { padding: 0 16px 18px; flex-direction: column; }
          .ub-modal-footer .ub-btn { width: 100%; justify-content: center; }
          .ub-pagination { flex-direction: column; align-items: center; }
          .ub-delete-btns { flex-direction: column; }
          .ub-delete-btns .ub-btn { width: 100%; justify-content: center; }
          .ub-page-btns { justify-content: center; }
          .ub-form-section { padding: 12px 12px; }
          .ub-file-zone { min-height: 70px; }
        }
        @media (max-width: 576px) {
          .ub-stat { padding: 16px 10px; border-radius: 14px; }
          .ub-stat-icon { width: 38px; height: 38px; font-size: 1rem; border-radius: 11px; margin-bottom: 10px; }
          .ub-stat-val { font-size: 1.3rem; }
          .ub-stat-lbl { font-size: 0.58rem; }
          .ub-stats { gap: 8px; }
          .ub-glass { border-radius: 18px; }
          .ub-input, .ub-select { font-size: 0.88rem; border-radius: 11px; }
          .ub-btn { border-radius: 11px; }
          .ub-action-btn { width: 40px; height: 40px; }
          .ub-detail-avatar { width: min(100%, 180px) !important; height: 180px !important; border-radius: 20px !important; }
        }
        @media (max-width: 400px) {
          .ub-stat-val { font-size: 1.1rem; }
          .ub-stat { padding: 14px 8px; }
        }
        @supports (-webkit-touch-callout: none) {
          .ub-app { min-height: 100dvh; }
          .ub-input, .ub-select, .ub-search { font-size: 16px; }
        }
        @media (hover: none) and (pointer: coarse) {
          .ub-stat:hover { transform: none; box-shadow: none; }
          .ub-input:hover:not(:focus) { border-color: rgba(11,61,145,0.06); }
        }
      `}</style>

      <div className="ub-root">
        <div className="ub-app">
          <div className="ub-content">

            {/* ═══ HEADER ═══ */}
            <div className="ub-header">
              <div className="ub-header-badge">
                <i className="bi bi-people-fill"></i> Sisitemu y'Urubyiruko
              </div>
              <h1 className="ub-title">Gucunga Urubyiruko</h1>
              <p className="ub-subtitle">Amakuru yose y'urubyiruko mu mudugudu ahantu hamwe</p>
            </div>

            {/* ═══ ALERT ═══ */}
            {alert.show && (
              <div className={`ub-alert ub-alert-${alert.variant}`}>
                <div className="ub-alert-icon" style={{
                  background: alert.variant === "success" ? "rgba(22,163,74,0.12)"
                    : alert.variant === "danger" ? "rgba(220,38,38,0.12)"
                    : alert.variant === "warning" ? "rgba(217,119,6,0.12)"
                    : "rgba(3,105,161,0.12)"
                }}>
                  <i className={`bi bi-${
                    alert.variant === "success" ? "check-lg"
                    : alert.variant === "danger" ? "exclamation-triangle-fill"
                    : alert.variant === "warning" ? "exclamation-circle-fill"
                    : "info-circle-fill"
                  }`}></i>
                </div>
                <span>{alert.message}</span>
                <button className="ub-alert-close" onClick={() => setAlert({ show: false, message: "", variant: "" })}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            )}

            {/* ═══ STATS ═══ */}
            <div className="ub-stats">
              <div className="ub-stat violet">
                <div className="ub-stat-icon" style={{ background: "rgba(11,61,145,0.12)", color: "#0B3D91" }}>
                  <i className="bi bi-people-fill"></i>
                </div>
                <div className="ub-stat-val">{stats.total}</div>
                <div className="ub-stat-lbl">Urubyiruko Rwose</div>
                <div className="ub-stat-sub">♂ {stats.male} · ♀ {stats.female}</div>
              </div>
              <div className="ub-stat emerald">
                <div className="ub-stat-icon" style={{ background: "rgba(22,163,74,0.12)", color: "#16a34a" }}>
                  <i className="bi bi-briefcase-fill"></i>
                </div>
                <div className="ub-stat-val">{stats.employed}</div>
                <div className="ub-stat-lbl">Bafite Akazi</div>
                <div className="ub-progress-track">
                  <div className="ub-progress-fill" style={{
                    width: `${stats.total ? (stats.employed / stats.total * 100) : 0}%`,
                    background: "linear-gradient(90deg, #16a34a, #16a34a)"
                  }}></div>
                </div>
              </div>
              <div className="ub-stat rose">
                <div className="ub-stat-icon" style={{ background: "rgba(220,38,38,0.12)", color: "#dc2626" }}>
                  <i className="bi bi-person-x-fill"></i>
                </div>
                <div className="ub-stat-val">{stats.unemployed}</div>
                <div className="ub-stat-lbl">Badafite Akazi</div>
                <div className="ub-progress-track">
                  <div className="ub-progress-fill" style={{
                    width: `${stats.total ? (stats.unemployed / stats.total * 100) : 0}%`,
                    background: "linear-gradient(90deg, #dc2626, #dc2626)"
                  }}></div>
                </div>
              </div>
              <div className="ub-stat amber">
                <div className="ub-stat-icon" style={{ background: "rgba(217,119,6,0.12)", color: "#d97706" }}>
                  <i className="bi bi-calendar-heart"></i>
                </div>
                <div className="ub-stat-val">{stats.avgAge}</div>
                <div className="ub-stat-lbl">Imyaka y'Icyiciro</div>
                <div className="ub-stat-sub">Average</div>
              </div>
            </div>

            {/* ═══ TOOLBAR ═══ */}
            <div className="ub-toolbar">
              <div className="ub-toolbar-left">
                <div className="ub-search-wrap">
                  <i className="bi bi-search ub-search-icon"></i>
                  <input
                    className="ub-search" type="search" placeholder="Shakisha amazina, telefoni, ID..."
                    value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
                  />
                </div>

                {/* Gender Filter */}
                <div style={{ position: "relative" }}>
                  <button
                    className={`ub-filter-chip ${filterGender !== "all" ? "active" : ""}`}
                    onClick={() => setOpenFilter(openFilter === "gender" ? null : "gender")}
                  >
                    <i className="bi bi-gender-ambiguous"></i>
                    {filterGender === "all" ? "Igitsina" : filterGender}
                    <i className="bi bi-chevron-down" style={{ fontSize: "0.65rem" }}></i>
                  </button>
                  {openFilter === "gender" && (
                    <div className="ub-filter-dropdown">
                      {["all", "Gabo", "Gore"].map(v => (
                        <button key={v} className={`ub-filter-option ${filterGender === v ? "selected" : ""}`}
                          onClick={() => { setFilterGender(v); setOpenFilter(null); }}>
                          {v === "all" ? "Byose" : v}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {/* Status Filter */}
                <div style={{ position: "relative" }}>
                  <button
                    className={`ub-filter-chip ${filterStatus !== "all" ? "active" : ""}`}
                    onClick={() => setOpenFilter(openFilter === "status" ? null : "status")}
                  >
                    <i className="bi bi-briefcase"></i>
                    {filterStatus === "all" ? "Status" : filterStatus.replace("Rufite akazi", "Akazi ✓").replace("Rudafite akazi", "Nta kazi")}
                    <i className="bi bi-chevron-down" style={{ fontSize: "0.65rem" }}></i>
                  </button>
                  {openFilter === "status" && (
                    <div className="ub-filter-dropdown">
                      {[{ v: "all", l: "Byose" }, { v: "Rufite akazi", l: "Rufite akazi" }, { v: "Rudafite akazi", l: "Rudafite akazi" }].map(({ v, l }) => (
                        <button key={v} className={`ub-filter-option ${filterStatus === v ? "selected" : ""}`}
                          onClick={() => { setFilterStatus(v); setOpenFilter(null); }}>
                          {l}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {/* Age Filter */}
                <div style={{ position: "relative" }}>
                  <button
                    className={`ub-filter-chip ${filterAge !== "all" ? "active" : ""}`}
                    onClick={() => setOpenFilter(openFilter === "age" ? null : "age")}
                  >
                    <i className="bi bi-calendar-range"></i>
                    {filterAge === "all" ? "Imyaka" : filterAge}
                    <i className="bi bi-chevron-down" style={{ fontSize: "0.65rem" }}></i>
                  </button>
                  {openFilter === "age" && (
                    <div className="ub-filter-dropdown">
                      {["all", "15-20", "21-25", "26-30", "31+"].map(v => (
                        <button key={v} className={`ub-filter-option ${filterAge === v ? "selected" : ""}`}
                          onClick={() => { setFilterAge(v); setOpenFilter(null); }}>
                          {v === "all" ? "Byose" : v}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {activeFilters > 0 && (
                  <button className="ub-filter-chip" style={{ color: "#dc2626", borderColor: "rgba(220,38,38,0.2)" }}
                    onClick={() => { setFilterGender("all"); setFilterStatus("all"); setFilterAge("all"); setSearchTerm(""); }}>
                    <i className="bi bi-x-circle"></i> Siba ({activeFilters})
                  </button>
                )}
              </div>

              <div className="ub-toolbar-right">
                <button className="ub-icon-btn" onClick={loadData} title="Refresh">
                  <i className="bi bi-arrow-clockwise"></i>
                </button>
                <button className="ub-icon-btn" onClick={exportToCSV} title="Export Excel">
                  <i className="bi bi-download"></i>
                </button>
                <button className="ub-icon-btn primary" onClick={() => { resetForm(); setShow(true); }} title="Ongeraho">
                  <i className="bi bi-plus-lg"></i>
                </button>
              </div>
            </div>

            {/* Click-away for filter dropdowns */}
            {openFilter && (
              <div style={{ position: "fixed", inset: 0, zIndex: 40 }} onClick={() => setOpenFilter(null)}></div>
            )}

            {/* ═══ TABLE / CARDS ═══ */}
            <div className="ub-glass" style={{ animation: "scaleIn 0.45s ease" }}>
              <div style={{ padding: "clamp(16px, 3vw, 28px)" }}>
                {loading ? (
                  <div className="ub-loader"><span></span><span></span><span></span></div>
                ) : currentItems.length === 0 ? (
                  <div className="ub-empty">
                    <div className="ub-empty-icon"><i className="bi bi-inbox"></i></div>
                    <h5 style={{ color: "#374151", fontWeight: 700, marginBottom: 6 }}>
                      Nta rubyiruko rubonetse
                    </h5>
                    <p style={{ color: "#64748b", fontSize: "0.85rem", maxWidth: 360, margin: "0 auto" }}>
                      {searchTerm || activeFilters > 0
                        ? "Hindura ibisuzuma cyangwa shakisha ijambo ritandukanye"
                        : "Tangira wongeraho urubyiruko mu sisitemu"}
                    </p>
                    {(searchTerm || activeFilters > 0) && (
                      <button className="ub-btn ub-btn-ghost" style={{ marginTop: 16 }}
                        onClick={() => { setFilterGender("all"); setFilterStatus("all"); setFilterAge("all"); setSearchTerm(""); }}>
                        <i className="bi bi-arrow-counterclockwise"></i> Siba ibisuzuma
                      </button>
                    )}
                  </div>
                ) : (
                  <>
                    {/* Desktop Table */}
                    <div className="ub-desktop-table">
                      <div className="ub-table-wrap">
                        <div className="ub-table-scroll">
                          <table className="ub-table">
                            <thead>
                              <tr>
                                <th style={{ paddingLeft: 20, width: 50 }}>#</th>
                                <th style={{ textAlign: "center", minWidth: 90 }}>Photos</th>
                                <th>Amazina</th>
                                <th style={{ textAlign: "center" }}>Imyaka</th>
                                <th style={{ textAlign: "center" }}>Igitsina</th>
                                <th>Umurimo</th>
                                <th style={{ textAlign: "center" }}>Telefoni</th>
                                <th style={{ textAlign: "center" }}>Status</th>
                                <th style={{ textAlign: "center", width: 120 }}>Ibikorwa</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentItems.map((item, idx) => {
                                const gc = genderColor(item.igitsina);
                                const sc = statusColor(item.status);
                                const photoUrl = getPhotoUrl(item.ifoto);
                                return (
                                  <tr key={item.id} style={{ animation: `slideRow 0.35s ease ${idx * 0.03}s both` }}>
                                    <td style={{ paddingLeft: 20, color: "#94a3b8", fontWeight: 600 }}>
                                      {indexOfFirst + idx + 1}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {photoUrl ? (
                                        <img
                                          src={photoUrl}
                                          alt={item.amazina}
                                          onError={handleImgError}
                                          style={{ width: 56, height: 56, borderRadius: 12, objectFit: "cover", border: "2px solid rgba(11,61,145,0.2)", display: "block", margin: "0 auto" }}
                                        />
                                      ) : (
                                        <span style={{ color: "#94a3b8", fontSize: "0.78rem", fontWeight: 600 }}>
                                          No Photo
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      <span style={{ fontWeight: 700, color: "#0d1b2a" }}>{item.amazina}</span>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <span className="ub-tag" style={{
                                        background: "rgba(11,61,145,0.1)", color: "#0B3D91", borderColor: "rgba(11,61,145,0.2)"
                                      }}>{item.imyaka}</span>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <span className="ub-tag" style={{ background: gc.bg, color: gc.color, borderColor: gc.border }}>
                                        {item.igitsina}
                                      </span>
                                    </td>
                                    <td style={{ color: item.umurimo ? "rgba(11,61,145,0.7)" : "rgba(11,61,145,0.2)" }}>
                                      {item.umurimo || "—"}
                                    </td>
                                    <td style={{ textAlign: "center", fontFamily: "monospace", fontSize: "0.82rem" }}>
                                      {item.nimero_ya_telephone || <span style={{ color: "rgba(11,61,145,0.15)" }}>—</span>}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <span className="ub-tag" style={{ background: sc.bg, color: sc.color, borderColor: sc.border }}>
                                        {item.status === "Rufite akazi" ? "✓ Akazi" : "✗ Nta kazi"}
                                      </span>
                                    </td>
                                    <td>
                                      <div className="ub-action-group">
                                        <button className="ub-action-btn view" title="Reba"
                                          onClick={() => { setSelectedYouth(item); setShowDetails(true); }}>
                                          <i className="bi bi-eye"></i>
                                        </button>
                                        <button className="ub-action-btn edit" title="Hindura"
                                          onClick={() => handleEdit(item)}>
                                          <i className="bi bi-pencil-square"></i>
                                        </button>
                                        <button className="ub-action-btn delete" title="Siba"
                                          onClick={() => setDeleteConfirm(item)}>
                                          <i className="bi bi-trash3"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    {/* Mobile Cards */}
                    <div>
                      {currentItems.map((item, idx) => {
                        const gc = genderColor(item.igitsina);
                        const sc = statusColor(item.status);
                        const isExpanded = expandedMobileCard === item.id;
                        const photoUrl = getPhotoUrl(item.ifoto);
                        return (
                          <div key={item.id} className="ub-mobile-card"
                            style={{ animation: `fadeUp 0.35s ease ${idx * 0.04}s both` }}
                            onClick={() => setExpandedMobileCard(isExpanded ? null : item.id)}>
                            <div className="ub-mc-head">
                              <div style={{ display: "flex", gap: 10, alignItems: "flex-start", minWidth: 0 }}>
                                {photoUrl ? (
                                  <img
                                    src={photoUrl}
                                    alt={item.amazina}
                                    onError={handleImgError}
                                    style={{ width: 48, height: 48, borderRadius: "50%", objectFit: "cover", border: "2px solid rgba(11,61,145,0.2)", flexShrink: 0 }}
                                  />
                                ) : (
                                  <div style={{ width: 48, height: 48, borderRadius: "50%", background: "rgba(11,61,145,0.12)", border: "1px solid rgba(11,61,145,0.2)", display: "flex", alignItems: "center", justifyContent: "center", color: "#0B3D91", flexShrink: 0 }}>
                                    <i className="bi bi-person-fill"></i>
                                  </div>
                                )}
                                <div style={{ minWidth: 0 }}>
                                  <div className="ub-mc-name">{item.amazina}</div>
                                  <div style={{ display: "flex", gap: 6 }}>
                                    <span className="ub-tag" style={{ background: gc.bg, color: gc.color, borderColor: gc.border, fontSize: "0.68rem" }}>
                                      {item.igitsina}
                                    </span>
                                    <span className="ub-tag" style={{ background: sc.bg, color: sc.color, borderColor: sc.border, fontSize: "0.68rem" }}>
                                      {item.status === "Rufite akazi" ? "✓ Akazi" : "✗ Nta kazi"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <span className="ub-tag" style={{
                                background: "rgba(11,61,145,0.1)", color: "#0B3D91",
                                borderColor: "rgba(11,61,145,0.2)", fontSize: "0.75rem", fontWeight: 800
                              }}>{item.imyaka}</span>
                            </div>
                            <div className="ub-mc-row">
                              <span className="ub-mc-lbl">Umurimo</span>
                              <span className="ub-mc-val">{item.umurimo || "—"}</span>
                            </div>
                            <div className="ub-mc-row">
                              <span className="ub-mc-lbl">Telefoni</span>
                              <span className="ub-mc-val" style={{ fontFamily: "monospace" }}>{item.nimero_ya_telephone || "—"}</span>
                            </div>
                            {isExpanded && (
                              <div style={{ animation: "fadeUp 0.3s ease" }}>
                                <div className="ub-mc-row">
                                  <span className="ub-mc-lbl">Aderesi</span>
                                  <span className="ub-mc-val">{item.aderesi || "—"}</span>
                                </div>
                                <div className="ub-mc-row">
                                  <span className="ub-mc-lbl">ID Number</span>
                                  <span className="ub-mc-val" style={{ fontFamily: "monospace", fontSize: "0.78rem" }}>{item.id_number || "—"}</span>
                                </div>
                                <div className="ub-mc-actions" onClick={e => e.stopPropagation()}>
                                  <button className="ub-btn ub-btn-ghost" style={{ fontSize: "0.78rem" }}
                                    onClick={() => { setSelectedYouth(item); setShowDetails(true); }}>
                                    <i className="bi bi-eye"></i> Reba
                                  </button>
                                  <button className="ub-btn" style={{
                                    background: "rgba(11,61,145,0.1)", color: "#0B3D91",
                                    border: "1px solid rgba(11,61,145,0.2)", fontSize: "0.78rem"
                                  }} onClick={() => handleEdit(item)}>
                                    <i className="bi bi-pencil-square"></i> Hindura
                                  </button>
                                  <button className="ub-btn ub-btn-danger" style={{ fontSize: "0.78rem" }}
                                    onClick={() => setDeleteConfirm(item)}>
                                    <i className="bi bi-trash3"></i> Siba
                                  </button>
                                </div>
                              </div>
                            )}
                            <div style={{ textAlign: "center", marginTop: 6, color: "#94a3b8", fontSize: "0.7rem" }}>
                              {isExpanded ? "▲" : "▼"}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                      <div className="ub-pagination">
                        <div className="ub-page-info">
                          {indexOfFirst + 1}–{Math.min(indexOfLast, filteredData.length)} / {filteredData.length}
                        </div>
                        <div className="ub-page-btns">
                          <button className="ub-page-btn" disabled={currentPage === 1}
                            onClick={() => setCurrentPage(1)}>
                            <i className="bi bi-chevron-double-left"></i>
                          </button>
                          <button className="ub-page-btn" disabled={currentPage === 1}
                            onClick={() => setCurrentPage(p => p - 1)}>
                            <i className="bi bi-chevron-left"></i>
                          </button>
                          {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(p => Math.abs(p - currentPage) <= 2 || p === 1 || p === totalPages)
                            .reduce((acc, p, i, arr) => {
                              if (i > 0 && p - arr[i - 1] > 1) acc.push("...");
                              acc.push(p);
                              return acc;
                            }, [])
                            .map((p, i) =>
                              p === "..." ? (
                                <span key={`dots-${i}`} style={{ color: "#94a3b8", padding: "0 4px", alignSelf: "center" }}>⋯</span>
                              ) : (
                                <button key={p} className={`ub-page-btn ${currentPage === p ? "active" : ""}`}
                                  onClick={() => setCurrentPage(p)}>
                                  {p}
                                </button>
                              )
                            )}
                          <button className="ub-page-btn" disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(p => p + 1)}>
                            <i className="bi bi-chevron-right"></i>
                          </button>
                          <button className="ub-page-btn" disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(totalPages)}>
                            <i className="bi bi-chevron-double-right"></i>
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            {/* ═══ ADD/EDIT MODAL ═══ */}
            {show && (
              <div className="ub-overlay" onClick={() => setShow(false)}>
                <div className="ub-modal" onClick={e => e.stopPropagation()}>
                  <div className="ub-modal-head">
                    <div className="ub-modal-title">
                      <div className="ub-modal-title-icon">
                        <i className={`bi bi-${editId ? "pencil-square" : "person-plus-fill"}`}></i>
                      </div>
                      <div>
                        <div>{editId ? "Hindura Amakuru" : "Ongeraho Umusore/Umukobwa"}</div>
                        <div style={{ fontSize: "0.78rem", color: "#64748b", fontWeight: 400 }}>
                          Uzuza amakuru yose akenewe
                        </div>
                      </div>
                    </div>
                    <button className="ub-modal-close" onClick={() => setShow(false)}>
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>

                  <div className="ub-modal-body" style={{ paddingTop: 20 }}>

                    {/* Section 1: Amakuru Shingiro */}
                    <div className="ub-form-section">
                      <div className="ub-form-section-title">
                        <i className="bi bi-person-badge"></i> Amakuru Shingiro
                      </div>
                      <div className="ub-form-grid ub-form-grid-2">
                        <div className="ub-field">
                          <label className="ub-label">Amazina <span className="ub-req">*</span></label>
                          <div className="ub-input-wrap">
                            <i className="bi bi-person ub-input-icon"></i>
                            <input className={`ub-input ${formErrors.amazina ? "error" : ""}`}
                              name="amazina" value={form.amazina} onChange={handleChange}
                              placeholder="Amazina yombi" />
                          </div>
                          {formErrors.amazina && <div className="ub-field-error"><i className="bi bi-exclamation-circle"></i>{formErrors.amazina}</div>}
                        </div>

                        <div className="ub-field">
                          <label className="ub-label">Imyaka <span className="ub-req">*</span></label>
                          <div className="ub-input-wrap">
                            <i className="bi bi-calendar ub-input-icon"></i>
                            <input className={`ub-input ${formErrors.imyaka ? "error" : ""}`}
                              type="number" name="imyaka" value={form.imyaka} onChange={handleChange}
                              placeholder="15–35" min="15" max="35" />
                          </div>
                          {formErrors.imyaka && <div className="ub-field-error"><i className="bi bi-exclamation-circle"></i>{formErrors.imyaka}</div>}
                        </div>

                        <div className="ub-field">
                          <label className="ub-label">Igitsina <span className="ub-req">*</span></label>
                          <div className="ub-input-wrap">
                            <i className="bi bi-gender-ambiguous ub-input-icon"></i>
                            <select className="ub-select" name="igitsina" value={form.igitsina} onChange={handleChange}>
                              <option value="Gabo">Gabo</option>
                              <option value="Gore">Gore</option>
                            </select>
                          </div>
                        </div>

                        <div className="ub-field">
                          <label className="ub-label">Status</label>
                          <div className="ub-input-wrap">
                            <i className="bi bi-briefcase ub-input-icon"></i>
                            <select className="ub-select" name="status" value={form.status} onChange={handleChange}>
                              <option value="Rudafite akazi">Rudafite akazi</option>
                              <option value="Rufite akazi">Rufite akazi</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Section 2: Akazi & Itumaini */}
                    <div className="ub-form-section">
                      <div className="ub-form-section-title">
                        <i className="bi bi-briefcase"></i> Akazi & Itumaini
                      </div>
                      <div className="ub-form-grid ub-form-grid-2">
                        <div className="ub-field">
                          <label className="ub-label">Umurimo</label>
                          <div className="ub-input-wrap">
                            <i className="bi bi-tools ub-input-icon"></i>
                            <input className="ub-input" name="umurimo" value={form.umurimo}
                              onChange={handleChange} placeholder="Akoramo iki?" />
                          </div>
                        </div>

                        <div className="ub-field">
                          <label className="ub-label">Telefoni</label>
                          <div className="ub-input-wrap">
                            <i className="bi bi-phone ub-input-icon"></i>
                            <input className={`ub-input ${formErrors.nimero_ya_telephone ? "error" : ""}`}
                              name="nimero_ya_telephone" value={form.nimero_ya_telephone}
                              onChange={handleChange} placeholder="078XXXXXXX" maxLength={10} />
                          </div>
                          {formErrors.nimero_ya_telephone && <div className="ub-field-error"><i className="bi bi-exclamation-circle"></i>{formErrors.nimero_ya_telephone}</div>}
                        </div>
                      </div>
                    </div>

                    {/* Section 3: Aho Atuye & ID */}
                    <div className="ub-form-section">
                      <div className="ub-form-section-title">
                        <i className="bi bi-geo-alt"></i> Aho Atuye & Indangamuntu
                      </div>
                      <div className="ub-form-grid ub-form-grid-2">
                        <div className="ub-field">
                          <label className="ub-label">Aderesi</label>
                          <div className="ub-input-wrap">
                            <i className="bi bi-geo-alt ub-input-icon"></i>
                            <input className="ub-input" name="aderesi" value={form.aderesi}
                              onChange={handleChange} placeholder="Aho atuye" />
                          </div>
                        </div>

                        <div className="ub-field">
                          <label className="ub-label">Indangamuntu (ID)</label>
                          <div className="ub-input-wrap">
                            <i className="bi bi-credit-card-2-front ub-input-icon"></i>
                            <input className={`ub-input ${formErrors.id_number ? "error" : ""}`}
                              name="id_number" value={form.id_number}
                              onChange={handleChange} placeholder="Imibare 16" maxLength={16} />
                          </div>
                          {formErrors.id_number && <div className="ub-field-error"><i className="bi bi-exclamation-circle"></i>{formErrors.id_number}</div>}
                        </div>
                      </div>
                    </div>

                    {/* Section 4: Ifoto */}
                    <div className="ub-field">
                      <label className="ub-label"><i className="bi bi-image"></i> Ifoto</label>
                      <div className={`ub-file-zone ${formErrors.ifoto ? "error" : ""} ${selectedFile || form.ifoto ? "has-file" : ""}`}>
                        <input type="file" accept=".jpg,.jpeg,.png,image/jpeg,image/png" onChange={handleFileChange} />
                        <div className="ub-file-icon">
                          <i className={`bi bi-${selectedFile || form.ifoto ? "check-circle-fill" : "cloud-arrow-up"}`}
                            style={{ color: selectedFile || form.ifoto ? "#16a34a" : "#0B3D91" }}></i>
                        </div>
                        <div className="ub-file-text">
                          {selectedFile ? (
                            <><div className="ub-file-name">{selectedFile.name}</div><div className="ub-file-sub">Ifoto yatoranijwe ✓</div></>
                          ) : form.ifoto ? (
                            <><div className="ub-file-name">{form.ifoto}</div><div className="ub-file-sub">Ifoto iriho — kanda guhindura</div></>
                          ) : (
                            <><div className="ub-file-title">Kanda cyangwa kujyana ifoto hano</div><div className="ub-file-sub">JPG, JPEG, PNG · Max 2MB</div></>
                          )}
                        </div>
                      </div>
                      {formErrors.ifoto && <div className="ub-field-error"><i className="bi bi-exclamation-circle"></i>{formErrors.ifoto}</div>}
                    </div>

                  </div>

                  <div className="ub-modal-footer">
                    <button className="ub-btn ub-btn-ghost" onClick={() => setShow(false)}>
                      <i className="bi bi-x"></i> Funga
                    </button>
                    <button className="ub-btn ub-btn-primary" onClick={handleSave}>
                      <i className={`bi bi-${editId ? "check2-circle" : "plus-circle"}`}></i>
                      {editId ? "Hindura" : "Bika"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ═══ DETAIL MODAL ═══ */}
            {showDetails && selectedYouth && (
              <div className="ub-overlay" onClick={() => setShowDetails(false)}>
                <div className="ub-modal" style={{ maxWidth: 720, width: "min(92vw, 720px)" }} onClick={e => e.stopPropagation()}>
                  <div className="ub-modal-head">
                    <div className="ub-modal-title">
                      <div className="ub-modal-title-icon" style={{
                        background: "linear-gradient(135deg, rgba(3,105,161,0.8), rgba(11,61,145,0.8))"
                      }}>
                        <i className="bi bi-person-lines-fill"></i>
                      </div>
                      Amakuru Arambuye
                    </div>
                    <button className="ub-modal-close" onClick={() => setShowDetails(false)}>
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                  <div className="ub-modal-body">
                    <div className="ub-detail-header" style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                      gap: 20,
                      alignItems: "center",
                      textAlign: "center",
                      paddingBottom: 24,
                      marginBottom: 18,
                    }}>
                      <div className="ub-detail-avatar" style={{
                        overflow: "hidden",
                        padding: 0,
                        width: "min(100%, 220px)",
                        height: 220,
                        borderRadius: 24,
                        margin: "0 auto",
                        boxShadow: "0 24px 48px rgba(11,61,145,0.45)",
                      }}>
                        {getPhotoUrl(selectedYouth.ifoto) ? (
                          <img
                            src={getPhotoUrl(selectedYouth.ifoto)}
                            alt={selectedYouth.amazina}
                            onError={handleImgError}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          />
                        ) : (
                          <div style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 8,
                            padding: "0 16px",
                            textAlign: "center",
                          }}>
                            <i className="bi bi-person-fill" style={{ color: "#0B3D91", fontSize: "2.8rem" }}></i>
                            <span style={{ color: "rgba(11,61,145,0.72)", fontSize: "0.82rem", fontWeight: 600 }}>
                              No Photo Available
                            </span>
                          </div>
                        )}
                      </div>
                      <div>
                        <div style={{
                          fontSize: "0.74rem",
                          textTransform: "uppercase",
                          letterSpacing: "0.14em",
                          color: "#64748b",
                          marginBottom: 10,
                        }}>
                          Ifoto y'umwirondoro
                        </div>
                        <h4 style={{ fontWeight: 800, color: "#0d1b2a", marginBottom: 8, fontSize: "1.5rem" }}>{selectedYouth.amazina}</h4>
                        <p style={{ color: "rgba(11,61,145,0.55)", fontSize: "0.88rem", marginBottom: 12 }}>
                          Iyi foto ifasha kumenya neza uyu muntu muri Amakuru Arambuye.
                        </p>
                        <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
                          <span className="ub-tag" style={{
                            ...(() => { const c = genderColor(selectedYouth.igitsina); return { background: c.bg, color: c.color, borderColor: c.border }; })()
                          }}>{selectedYouth.igitsina}</span>
                          <span className="ub-tag" style={{
                            ...(() => { const c = statusColor(selectedYouth.status); return { background: c.bg, color: c.color, borderColor: c.border }; })()
                          }}>{selectedYouth.status}</span>
                        </div>
                      </div>
                    </div>

                    <div className="ub-detail-row">
                      <span className="ub-detail-lbl"><i className="bi bi-calendar me-2"></i>Imyaka</span>
                      <span className="ub-detail-val">{selectedYouth.imyaka}</span>
                    </div>
                    <div className="ub-detail-row">
                      <span className="ub-detail-lbl"><i className="bi bi-tools me-2"></i>Umurimo</span>
                      <span className="ub-detail-val">{selectedYouth.umurimo || "—"}</span>
                    </div>
                    <div className="ub-detail-row">
                      <span className="ub-detail-lbl"><i className="bi bi-phone me-2"></i>Telefoni</span>
                      <span className="ub-detail-val" style={{ fontFamily: "monospace" }}>{selectedYouth.nimero_ya_telephone || "—"}</span>
                    </div>
                    <div className="ub-detail-row">
                      <span className="ub-detail-lbl"><i className="bi bi-geo-alt me-2"></i>Aderesi</span>
                      <span className="ub-detail-val">{selectedYouth.aderesi || "—"}</span>
                    </div>
                    <div className="ub-detail-row">
                      <span className="ub-detail-lbl"><i className="bi bi-credit-card-2-front me-2"></i>ID</span>
                      <span className="ub-detail-val" style={{ fontFamily: "monospace", fontSize: "0.82rem" }}>{selectedYouth.id_number || "—"}</span>
                    </div>
                  </div>
                  <div className="ub-modal-footer">
                    <button className="ub-btn ub-btn-ghost" onClick={() => setShowDetails(false)}>
                      Funga
                    </button>
                    <button className="ub-btn" style={{
                      background: "rgba(11,61,145,0.1)", color: "#0B3D91",
                      border: "1px solid rgba(11,61,145,0.2)"
                    }} onClick={() => { setShowDetails(false); handleEdit(selectedYouth); }}>
                      <i className="bi bi-pencil-square"></i> Hindura
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ═══ DELETE CONFIRM ═══ */}
            {deleteConfirm && (
              <div className="ub-overlay" onClick={() => setDeleteConfirm(null)}>
                <div className="ub-modal ub-delete-modal" onClick={e => e.stopPropagation()} style={{
                  background: "linear-gradient(145deg, rgba(255,255,255,0.98), rgba(240,244,251,0.99))"
                }}>
                  <div className="ub-delete-icon">
                    <i className="bi bi-exclamation-triangle-fill"></i>
                  </div>
                  <h4 style={{ fontWeight: 800, color: "#0d1b2a", marginBottom: 8 }}>Gusiba?</h4>
                  <p style={{ color: "#64748b", fontSize: "0.88rem", marginBottom: 4 }}>
                    Uremeza ko ushaka gusiba amakuru ya:
                  </p>
                  <p style={{ color: "#0d1b2a", fontWeight: 700, fontSize: "1.05rem" }}>
                    {deleteConfirm.amazina}
                  </p>
                  <div className="ub-delete-btns">
                    <button className="ub-btn ub-btn-ghost" onClick={() => setDeleteConfirm(null)}>
                      <i className="bi bi-x"></i> Oya, Reka
                    </button>
                    <button className="ub-btn ub-btn-danger" onClick={() => handleDelete(deleteConfirm.id)}>
                      <i className="bi bi-trash3"></i> Yego, Siba
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Footer */}
            <div className="ub-footer">
              <i className="bi bi-shield-lock-fill" style={{ marginRight: 6 }}></i>
              Amakuru yose arindwa kandi akoreshwa ku buryo bw'amategeko
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Urubyiruko;